import React, { useEffect } from 'react'
import { BCEntityBase } from '../models/shared/BCEntityBase';
import { azureGetCustomers } from '../utils/api';
import { useAuth } from 'reactfire';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';

interface Props {
    companyId: string
    customerId: string
    onChange: (customerId: string, customerName: string) => void
}

export default function AzureCustomerPicker({ companyId, customerId, onChange }: Props) {
    const [candidates, setCandidates] = React.useState<BCEntityBase[]>([]);
    const [processing, setProcessing] = React.useState(false);
    const { currentUser } = useAuth();

    useEffect(() => {
        if (!companyId) {
            setCandidates([]);
            return;
        }
        const fetchCandidates = async () => {
            setProcessing(true);

            try {
                const token = await currentUser?.getIdToken();
                const candidates = await azureGetCustomers(token, companyId);
                setCandidates(candidates);
            } catch (error) {
                console.error('Failed to fetch Azure customers:', error);
                toast.error('Failed to fetch Azure customers. Please try again later.');
            }
            setProcessing(false);
        }

        fetchCandidates();
    }, [companyId, currentUser])


    return (
        <div>
            <div>
                <label>Select BC Customer</label>
                {processing && <Spinner animation="border" size="sm" className='ms-2' />}
            </div>
            <select className='form-select' value={customerId || ''} onChange={(e) => onChange?.(e.target.value, e.target.options[e.target.selectedIndex].text)}
                disabled={processing || candidates.length === 0}
            >
                <option value=''>Select a customer</option>
                {candidates.map(customer => (
                    <option key={customer.id} value={customer.id}>{customer.name}</option>
                ))}
            </select>

        </div>
    )
}
